import React from 'react'
import {Helmet} from "react-helmet";
const Careers = () => {
  return (
    <div>
        <Helmet>
                <meta charSet="utf-8" />
                <title>Careers - Otter Tutor</title>
                <link rel="canonical" href="http://ottertutors.com" />
            </Helmet>
        <h1 style={{textAlign:'center'}}>Coming Soon...</h1>
    </div>
  )
}

export default Careers